module.exports = __webpack_public_path__ + "media/images/WFC_Portrait_Black-1423ad382a62c681db7b8b6b87c89d98.png";